export default {
  layout: ({ layout }) => layout,
  configuration: ({ configuration }) => configuration,
  errors: ({ errors }) => errors,
  name: ({ name }) => name,
  email: ({ email }) => email,
  password: ({ password }) => password,
  operationCountry: ({ operationCountry }) => operationCountry,
  stage: ({ stage }) => stage,
  price: ({ price }) => price,
  stripePaymentMethodId: ({ stripePaymentMethodId }) => stripePaymentMethodId,
  registrationToken: ({ registrationToken }) => registrationToken,
  stripeRedirect: ({ stripeRedirect }) => stripeRedirect,
  discountMetaData({ discountMetaData }) {
    if (discountMetaData) {
      if (
        discountMetaData.description ||
        discountMetaData.title
      ) {
        return {
          ...discountMetaData,
          title: discountMetaData.description ?? discountMetaData.title
        };
      }

      return discountMetaData;
    }
    return null;
  },
};
